import { ElLoading } from 'element-plus'; //ui组件
import LogoData from './Logo';

export default {
	LoadingShow:(Data) => {
		if(Data == '' || Data == null || Data == undefined){
			Data = 'Loading...';
		}
		const Loading = ElLoading.service({
			lock: true,
			text: Data,
			background: 'rgba(0,0,0,0)',
			svg: LogoData.LogoSvg(),
			svgViewBox: '0 0 100 100',
		})
	},
	LoadingHide:(Data) => {
		if(Data == '' || Data == null || Data == undefined){
			Data = 'Loading';
		}
		const Loading = ElLoading.service({
			lock: true,
			text: Data,
			background: 'rgba(0,0,0,0)',
			svg: LogoData.LogoSvg(),
			svgViewBox: '0 0 100 100',
		})
		Loading.close();
	}
}

